import { render, staticRenderFns } from "./HelpCardContent.vue?vue&type=template&id=67cdd1be&scoped=true&"
import script from "./HelpCardContent.vue?vue&type=script&lang=js&"
export * from "./HelpCardContent.vue?vue&type=script&lang=js&"
import style0 from "./HelpCardContent.vue?vue&type=style&index=0&id=67cdd1be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cdd1be",
  null
  
)

export default component.exports